<div class="tooltip-btn h3-bold type-{{ Type }} size-{{ size }}">
  <img alt="" height="16" width="16" class="warning-icon" ngSrc="../assets/alert.svg" />{{ label }}
</div>
<ng-content></ng-content>
